import { DropZone } from '../../../../../components/DropZone/DropZone'
import { ModalComponent } from '../../../../../components/Modal/ModalComponent/ModalComponent'
import './ModalCoverProject.scss'

const imgArr = [
  'https://apps1.ecomru.ru:9001/developerimages/banner_1.svg',
  'https://apps1.ecomru.ru:9001/developerimages/banner_2.svg',
  'https://apps1.ecomru.ru:9001/developerimages/banner_3.svg',
  'https://apps1.ecomru.ru:9001/developerimages/banner_4.svg',
  'https://apps1.ecomru.ru:9001/developerimages/banner_5.svg',
  'https://apps1.ecomru.ru:9001/developerimages/banner_6.svg',
  'https://apps1.ecomru.ru:9001/developerimages/banner_7.svg',
  'https://apps1.ecomru.ru:9001/developerimages/banner_8.svg',
  'https://apps1.ecomru.ru:9001/developerimages/banner_9.svg',
];

const ModalCoverProject = ({ 
    setIsModal,
    currentCover, 
    setCurrentCover, 
    fetchAddImageProject
 }) => {

    const loadImg = (e) => {
        setCurrentCover(e)
        fetchAddImageProject(e)
        setIsModal(false)
    }

    return (
        <ModalComponent
            title='Выберите обложку'
            onClose={(e) => setIsModal(false)}
            style={{
                height: 'auto',
                maxWidth: '700px'
            }}
            child={
                <div className='modal-cover-project'>
                    <div className='modal-cover-project__content'>
                        <DropZone setSave={(e) => {
                            loadImg(e)
                        }} />

                        <div className='modal-cover-project__img-group'>
                            {imgArr.map((img, ind) =>
                                <div className={`modal-cover-project__img-box${currentCover == img ? '_active' : ''}`}
                                    key={ind + img}
                                    onClick={(e) => {
                                        setCurrentCover(img)
                                        fetchAddImageProject(img)
                                        setIsModal(false)
                                    }} >
                                    <img src={img} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>}
        />
    )
}

export { ModalCoverProject }